import { render } from "./PodcastPage.vue?vue&type=template&id=0324c4e7&ts=true"
import script from "./PodcastPage.vue?vue&type=script&lang=ts"
export * from "./PodcastPage.vue?vue&type=script&lang=ts"

import "./PodcastPage.vue?vue&type=style&index=0&id=0324c4e7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__